/**
* ニュース管理
* ひとまずは記事を直接記載
* 今後はwpから取得するようにする
*/

const actions = {
};

const mutations = {
};

const state = {
  articles: [
    {
      slug: 'acraft',
      date: '2025.02.27',
      title: 'ACRAFTオープン記念コラボレーション',
      kv: '/img/news/NEWS_1.jpg',
      content: `<h2>各¥165,000(税込)</h2>
<p>コンテンポラリーアートとしての“DENIM DARUMA”を製作する清水葵氏による『ACRAFT』に、オープンを記念して別注を依頼致しました。<br>
東京を代表するデザイナーである<br>
尾花 大輔氏(N.HOOLYWOOD)、<br>
相澤 陽介氏(White Mountaineering)、<br>
清水慶三氏 (NEEDLES/NEPENTHES代表)の私物やサンプルの生地を使用した全て一点物の特注カスタム DARUMAを製作していただきました。</p>
<p>&nbsp;</p>
<p>ACRAFT公式instaagram<br>
<a href="https://www.instagram.com/a.craft86/" target="_blank">https://www.instagram.com/a.craft86/</a></p>
<p>&nbsp;</p>
<p>店舗情報<br>
GOOD EDITION原宿<br>
〒150-0001 東京都渋谷区神宮前4-27-2 1-2F<br>
03-6804-5422</p>`,
    },
    {
      slug: 'humanrobot',
      date: '2025.02.27',
      title: 'HUMAN ROBOTオープン記念コラボレーション',
      kv: '/img/news/NEWS_2.jpg',
      content: `<h2>各¥7,480(税込)</h2>
<p>個性的なソフトビニールフィギュアでカプセルトイとしても人気の「HUMAN ROBOT」より、オリジナルキャラクターPAN DEAD(パンのゾンビ)のGOOD EDITION別注カラーを制作致しました。
シルバーカラーがベースで胴体には「GOOD EDITION」のロゴが入っており、4種のキャラクター、(画像左から)コロネン・ショックン・メロロン・ワッサンが揃います。</p>
<p>&nbsp;</p>
<p>HUMAN ROBOT公式instaagram<br>
<a href="https://www.instagram.com/humanrobot_toys/" target="_blank">https://www.instagram.com/humanrobot_toys/</a></p>
<p>&nbsp;</p>
<p>店舗情報<br>
GOOD EDITION原宿<br>
〒150-0001 東京都渋谷区神宮前4-27-2 1-2F<br>
03-6804-5422</p>`,
    },
    {
      slug: 'shogosekine',
      date: '2025.02.27',
      title: 'SHOGO SEKINE オープン記念コラボレーション',
      kv: '/img/news/NEWS_3.jpg',
      content: `<h2>デザイントートバック・タンブラー 各￥4,400(税込)<br>HanesパックT 各￥6,600(税込)</h2>
<p>オファーが絶えない人気イラストレーターSHOGO SEKINE氏にオープンを記念し、デザインを依頼致しました。<br>
ショップ名にちなみ「good good good」をあしらったトートバッグ、タンブラー、HanesのパックTをご用意致しました。<br>
日常をポップに彩るアイテムとなっております。</p>
<p>&nbsp;</p>
<p>SHOGO SEKINE公式instaagram<br>
<a href="https://www.instagram.com/shogosekine0319/" target="_blank">https://www.instagram.com/shogosekine0319/</a></p>
<p>&nbsp;</p>
<p>店舗情報<br>
GOOD EDITION原宿<br>
〒150-0001 東京都渋谷区神宮前4-27-2 1-2F<br>
03-6804-5422</p>`,
    },
  ],
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
